import { Style } from 'index';

const ProjectExtractionStep: Style = {
    progressCircle: {
        position: 'absolute',
        right: 0,
        backgroundColor: '#ededed',
        borderRadius: '50%',
    },
    checkIcon: {
        color: 'success.main',
        marginBottom: '5px',
    },
    uncategorizedIcon: {
        color: 'warning.dark',
        marginBottom: '5px',
    },
    saveForLater: {
        color: 'info.main',
        marginBottom: '5px',
    },
};

export default ProjectExtractionStep;
